import Tracked from '~/components/Tracked';

import Splash from './Splash';

export default function LaunchPage() {
  return (
    <div className="flex w-full flex-col gap-0">
      <Splash />
      <VisitMainSite />
    </div>
  );
}

function VisitMainSite() {
  return (
    <div className="flex w-full items-center justify-between bg-golden-syrup px-4 py-2 lg:justify-center lg:gap-6 lg:px-0">
      <span className="font-semibold">Kommt bald nach Deutschland</span>
      <Tracked.ExternalLink
        pagePosition="TEMP_DE_SPLASH"
        name="UK_SITE"
        variant="none"
        href="https://thesolesupplier.co.uk/"
        className="rounded-lg border border-black px-[10px] py-2 font-bold"
      >
        🇬🇧 UK-Site
      </Tracked.ExternalLink>
    </div>
  );
}
